//import React from "react";
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// react component
import ReactTable from "react-table";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import Select from "react-select";
import { ValidSelect } from "beaktShared/helpers/validselect";
import FormHelperText from "@material-ui/core/FormHelperText";

// @material-ui/icons
import Search from "@material-ui/icons/Search";
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import { GerenciaModal } from "beaktShared/views/Crud/ModalDetail";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import Close from "@material-ui/icons/Close";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const useStyles = makeStyles(styles);

export default function RegistrarContatoList({ itemcampanha, handleViewContato, btnRegistraContato }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const { register, handleSubmit, setValue,errors } = useForm({ mode: "onChange" });
    const session = useContext(SessionContext);

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification(prev => ({ ...prev, show: false }));
        }, 4000);
    };

    const endPoint = "campanhas/";

    const TiposContato = [
        { id: 0, title: 'Selecione' },
        { id: 2, title: 'Email' },
        { id: 3, title: 'Telefone' },
        { id: 4, title: 'WhatsApp' },
        { id: 5, title: 'Rede Social' },
        { id: 6, title: 'Carta' }
    ];

    const [campanhaClienteId, setcampanhaClienteId] = React.useState(0);
    const [campanhaId, setcampanhaId] = React.useState(0);
    const [listCampanhaClientes, setlistCampanhaClientes] = React.useState([]);
    const [isLoadingListaClientes, setisLoadingListaClientes] = React.useState(false);

    useEffect(() => {
        setisLoadingListaClientes(true);
        setlistCampanhaClientes(itemcampanha);
        setisLoadingListaClientes(false);

    }, [itemcampanha]);

    // Detalhe dos contatos feitos com o cliente selecionado
    const [detailModal, setConfModal] = GerenciaModal();
    const handleDetail = row => {
        let endPointGetCampanha = endPoint + "contatosbycliente/" + row.campanhaClienteId;

        UseGetApiSimple(endPointGetCampanha, 0).then(result => {
            if (result.status !== 200) {
                return false;
            }
            const bodyDetail = (
                <div>
                    <p><b>{t('label.client')}:</b> {row.nome}</p>
                    <p><b>{t('label.contacts')}:</b></p>

                    {
                        result.data.map((obj, key) => {
                            return <div key={key}>
                                <p><b>{t('label.contacts_type')}:</b>
                                    {obj.tipo === 1 ? "Correio Eletrônico" : obj.tipo === 2 ? "Email" : obj.tipo === 3 ? "Telefone" :
                                        obj.tipo === 4 ? "WhatsApp" : obj.tipo === 5 ? "RedeSocial" :
                                            obj.tipo === 6 ? "Carta" : ""}</p>
                                <p><b>{t('label.user')}:</b> {obj.usuarioContato}</p>
                                <p><b>{t('label.obs_action')}:</b> {obj.observacao}</p>
                                <hr></hr>
                            </div>
                        })
                    }
                </div>
            );
            setConfModal({
                showmodal: true,
                dataShow: bodyDetail
            });
        });

    };
    //REGISTRAR CONTATO
    const [showModal, setshowModal] = React.useState(false);
    const [tipocontato, settipocontato] = React.useState(0);

    const openDialog = (row) => {

        setValue('nomeCliente', row.nome);
        setcampanhaClienteId(row.campanhaClienteId);
        setcampanhaId(row.campanhaId);

        setshowModal(true);
    }

    const handleTipoContato = (value) => {
        settipocontato(value);
    }

    const [loadingSaveContato, setloadingSaveContato] = React.useState(false);
    const onSubmit = (data, e) => {
        e.preventDefault();

        if (tipocontato == 0) {
            showNotification('Preencha o tipo do contato!', 'danger');
            return;
        }

        let contato = {
            campanhaClienteId: campanhaClienteId,
            tipo: tipocontato,
            usuarioContato: session.id,
            observacao: data.observacao
        };

        let endPointPost = endPoint + "savecontatocliente/"
        setloadingSaveContato(true);
        UsePostApi(endPointPost, contato).then(result => {
            if (result.status !== 200) {
                showNotification(result.message.message, 'danger');
                setloadingSaveContato(false);
                return false;
            }
            showNotification(result.message, 'success');
            setloadingSaveContato(false);
            CloseDialog();

            LoadListClientesContato();
            return true;
        });
    }

    //limpa Dialog
    const CloseDialog = () => {
        settipocontato(0);
        setValue('nomeCliente', "");
        setValue('observacao', "");
        setcampanhaClienteId(0);
        setshowModal(false);
    }

    //Atualiza lista de Clientes 
    const LoadListClientesContato = () => {
        setlistCampanhaClientes([]);

        let endPointGetCampanha = endPoint + "clientescontatobycampanha/" + campanhaId;
        setisLoadingListaClientes(true);
        UseGetApiSimple(endPointGetCampanha, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message.message, 'danger');
                setisLoadingListaClientes(false);
                return false;
            }
            setlistCampanhaClientes(result.data);
            setisLoadingListaClientes(false);
            return true;
        });
    };

    //colunas Table e Ações
    const columnsProp = [{
        Header: t('label.name'),
        accessor: "nome",
    },
    {
        Header: t('label.email'),
        accessor: "email",
    },
    {
        Header: t('label.cell_phone'),
        accessor: "celular",
    },
    {
        Header: t('label.qtd_contacts'),
        accessor: "qtdContatos",
    }]

    const columnsAcao = [
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">
                    {row.original.qtdContatos != 0 &&

                        <Button
                            justIcon
                            round
                            simple
                            color="info"
                            className="info"
                            onClick={() => handleDetail(row.original)}
                        >
                            <Search />
                        </Button>
                    }
                    {btnRegistraContato &&
                        <Button
                            justIcon
                            round
                            simple
                            color="success"
                            className="success"
                            onClick={() => openDialog(row.original)}
                        >
                            <PlaylistAddCheckIcon />
                        </Button>
                    }

                </div>
            ),
            sortable: false,
            filterable: false
        }
    ];
    const columns = [...columnsProp, ...columnsAcao]

    const handleCancelar = () => {
        handleViewContato(false)
    }

    return (

        <div>

            <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification(prev => ({ ...prev, show: false }))}
                close
            />
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardBody>
                            {btnRegistraContato &&
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <div className="subTitulo">
                                            <h6>{t('label.register_contact')} </h6>
                                        </div>
                                    </GridItem>
                                </GridContainer>}
                            <ReactTable
                                loading={isLoadingListaClientes}
                                data={listCampanhaClientes}
                                columns={columns}
                                filterable={false}
                                defaultPageSize={10}
                                minRows={5}
                                showPaginationBottom={true}
                                className="-striped -highlight"
                                previousText={t('button.previous')}
                                nextText={t('button.next')}
                                loadingText={t('label.loading') + "..."}
                                noDataText={t('information_message.no_records_found') + "!"}
                                pageText={t('label.page')}
                                ofText={t('label.of')}
                                rowsText={t('label.rows')}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
                <Dialog
                    classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalRoot }}
                    open={showModal}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => CloseDialog()}
                    aria-labelledby="classic-modal-slide-title"
                    aria-describedby="classic-modal-slide-description"
                >
                    <DialogTitle
                        id="classic-modal-slide-title"
                        disableTypography
                        className={classes.modalHeader}
                        style={{ background: '#5c4477' }}
                    >
                        <Button
                            justIcon
                            className={classes.modalCloseButton}
                            key="close"
                            aria-label="Close"
                            color="transparent"
                            onClick={() => CloseDialog()}
                        >
                            <Close className={classes.modalClose} />
                        </Button>
                        <h4 className={classes.modalTitle} style={{ color: 'white' }}>Registrar Contato</h4>
                    </DialogTitle>
                    <DialogContent id="classic-modal-slide-description"
                        className={classes.modalBody}
                    >
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={8}>
                                    <br></br>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <TextField
                                            label={t('label.name')}
                                            variant="outlined"
                                            disabled={true}
                                            inputRef={register({ required: false })}
                                            name="nomeCliente"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <label className={errors.tipocontato ? "select__label select__label_error" : "select__label"}>{t('label.contacts_type') + " *"} </label>
                                        <Select
                                            classNamePrefix="select"
                                            styles={ValidSelect(errors.tipocontato ? true : false)}
                                            isSearchable={true}
                                            name="tipocontato"
                                            placeholder={t('label.select') + " ..."}
                                            options={TiposContato}
                                            value={TiposContato.filter(({ id }) => id === tipocontato)}
                                            getOptionLabel={({ title }) => title}
                                            getOptionValue={({ id }) => id}
                                            onChange={(value) => handleTipoContato(value.id)}
                                            ref={() => register(
                                                { name: "tipocontato" })
                                            }
                                        />
                                        <FormHelperText className={classes.labelRootError}>
                                            {errors.tipocontato && <span>{t('label.required')}</span>}
                                        </FormHelperText>
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <TextField
                                            error={errors.observacao ? true : false}
                                            label={t('label.obs')}
                                            variant="outlined"
                                            inputRef={register}
                                            name="observacao"
                                            InputLabelProps={{ shrink: true }}
                                            multiline
                                            rowsMax="3"
                                            rows="2"
                                            inputProps={{ maxLength: 500 }}
                                        />
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <center>
                                        <Button type="submit" color="primary">
                                            {t('button.to_save')} {loadingSaveContato && <div> ... {t('label.loading')}</div>}
                                        </Button>
                                    </center>
                                    <br />
                                </GridItem>
                            </GridContainer>
                        </form>
                    </DialogContent>
                </Dialog>
            </GridContainer>
            {btnRegistraContato &&
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                        <Button onClick={() => handleCancelar()} color="transparent" className={classes.updateProfileButton}>
                            {t('button.cancel')}
                        </Button>
                    </GridItem>
                </GridContainer>
            }

            {detailModal}

        </div>
    );
}